import { render, staticRenderFns } from "./AddRoleModal.vue?vue&type=template&id=08b2f03e&"
import script from "./AddRoleModal.vue?vue&type=script&lang=js&"
export * from "./AddRoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports